import { get } from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";
import { EmailSuggestionMessage } from "./EmailSuggestionMessage";

const Wrapper = styled.div`
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e3342f;
`;

export const InputErrorMessage = ({ name, message = null, ...props }) => {
    const {
        formState: { errors }
    } = useFormContext();
    const error = get(errors, name);

    const renderMessage = () => {
        if (typeof error?.message === "string") return <EmailSuggestionMessage name={name} message={error.message} />;
        if (Array.isArray(error)) return error.map((value, index) => <span
            className="tw-block" key={index}
        >{value?.message}</span>);
        return error?.message;
    };

    return error ? (
        <Wrapper className="input-error-message" {...props}>
            {message ?? renderMessage()}
        </Wrapper>
    ) : null;
};
